import React from "react";
import { useNavigate } from "react-router-dom";

export default function PageError() {
  const navigate = useNavigate();
  return (
    <div className="min-vh-100  d-flex justify-content-center align-items-center">
      <div className="text-center text-dark">
        <i className="display-1 fw-bold">404</i>
        <p className="ri-30px">
          Sorry, the page you're looking for doesn't exist.
        </p>

        <button onClick={() => navigate(-1)} className="btn btn-primary mt-4">
          Go to Back
        </button>
      </div>
    </div>
  );
}
